
function getCartItems() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: '/cart.js',
            type: 'GET',
            dataType: 'json',
            success: function(cart) {
                const cartItems = cart.items.map(item => ({
                    id: item.id.toString(),
                    title: item.title,
                    quantity: item.quantity,
                    price: (item.price / 100).toFixed(2),
                    originalPrice: item.original_price ? (item.original_price / 100).toFixed(2) : '',
                    properties: item.properties || {},
                    options: item.options_with_values || [],
                    imageUrl: item.image
                }));
                resolve(cartItems);
            },
            error: function(xhr, status, error) {
                console.error('Error fetching cart data:', error);
                // Fallback to DOM approach if cart.js fails
                const cartItems = [];
                $('#main-cart-items .cart-item').each(function() {
                    const $item = $(this);
                    const domPrice = $item.find('.cart-item__final-price').text().trim()
                        .replace(/[^0-9.]/g, '');
                    const price = parseFloat(domPrice).toFixed(2);

                    const item = {
                        id: $item.attr('id'),
                        title: $item.find('.cart-item__name').text().trim(),
                        quantity: parseInt($item.find('.quantity__input').val(), 10) || 1,
                        price: isNaN(price) ? "0.00" : price,
                        originalPrice: $item.find('.cart-item__old-price').text().trim(),
                        imageUrl: $item.find('.cart-item__image').attr('src'),
                        properties: {},
                        options: []
                    };

                    // Extract properties
                    $item.find('.product-option').each(function() {
                        const propertyName = $(this).find('dt').text().trim();
                        const propertyValue = $(this).find('dd').text().trim();
                        if (propertyName && propertyValue) {
                            item.properties[propertyName] = propertyValue;
                        }
                    });

                    cartItems.push(item);
                });
                resolve(cartItems);
            }
        });
    });
}

async function saveCartItemsToLocalStorage() {
    try {
        const cartItems = await getCartItems();
        window.localStorage.setItem('cartItems', JSON.stringify(cartItems));
        console.log('Cart items saved:', cartItems);
    } catch (error) {
        console.error('Error saving cart items:', error);
    }
}

$(document).ready(function() {
    saveCartItemsToLocalStorage();
});

// Update cart items whenever quantity changes
$(document).on('change', '.quantity__input', function() {
    saveCartItemsToLocalStorage();
});

// Update cart items whenever an item is removed
$(document).on('click', '.cart-item__remove-button', function() {
    // Wait a brief moment for the DOM to update
    setTimeout(saveCartItemsToLocalStorage, 100);
});

$(document).on("click", ".button.button-1.button-checkout.button-enable, .button.button-1.button-checkout, .cart__checkout-button.button, .button.button--primary.button--full-width", function (event) {

    event.preventDefault();
  
    // Save cart items immediately before processing
    saveCartItemsToLocalStorage().then(() => {
        const cartItems = window.localStorage.getItem('cartItems') || "[]";
        console.log('Cart Items at checkout:', cartItems);

        $.ajax({
            url: "/cart?view=hulkapps_cart_collections.json",
            success: function (e) {
                localStorage.setItem('collection_data', JSON.stringify(e));
                const collection_data = window.localStorage.getItem('collection_data') || "[]";
                
                console.log('Collection data:', collection_data);

                $.ajax({
                    type: "POST",
                    url: "https://app.701apparel.com/create_draft_order",
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    data: {
                        product_Data: window.localStorage.productData || "",
                        customer_Data: window.localStorage.customerData || "",
                        cart_Items: cartItems,
                        collection_data: collection_data
                    },
                    crossDomain: true,
                    success: function (response) {
                        console.log('Draft order created successfully:', response);
                        window.localStorage.setItem('draftOrder', JSON.stringify(response.data));
                        window.location.href = response.data.invoiceUrl;
                    },
                    error: function (xhr, status, error) {
                        console.error('Error creating draft order:', xhr.responseText || error);
                        alert("An error occurred while creating the draft order.");
                    }
                });
            },
            error: function (e) {
                console.log('Error fetching collection data');
                console.log(e);
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', function() {
    // Create and add style tag
    const styleTag = document.createElement('style');
    styleTag.textContent = `
        .cart-item-properties {
            max-width: 100% !important;
        }
    `;
    document.head.appendChild(styleTag);
});
